import React, { useEffect, useRef } from 'react';
import { graphql } from 'gatsby';
import { KontentStringValue } from '../../../types/KontentProps';
import loadable from '@loadable/component';

const Jotform = loadable(() => import('../Jotform'));

export interface Props {
    form_url: KontentStringValue;
    anchor_name: KontentStringValue;
    kontentItemId?: string;
}

const GeneralJotform: React.FC<Props> = ({
    form_url,
    anchor_name,
    kontentItemId,
    ...props
}) => {
    return (
        <section
            id={anchor_name?.value}
            style={{ margin: 'var(--desktop-component-buffer)' }}
            data-kontent-item-id={kontentItemId}
        >
            <Jotform
                formStyle="embed"
                formUrl={form_url.value}
                display={true}
            />
        </section>
    );
};

export default GeneralJotform;

export const fragmentGeneralJotform = graphql`
    fragment GeneralJotform on kontent_item_component___form_container {
        elements {
            form_url {
                value
            }
            placement {
                value {
                    name
                }
            }
            anchor_name {
                value
            }
        }
    }
`;
